import React, { useContext } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import loadable from '@loadable/component';
import FeatureThumbnailContext from '../../../context/FeatureThumbnailContext';
import { makeStyles } from '@material-ui/core/styles';

const Video = loadable(() => import('../../Home/Hero/Video'));
const useStyles = makeStyles((theme) => ({
  sectionImage: {
    maxWidth: '700px',
    minWidth: '420px',
    objectFit: 'contain',
    transition: '.5s',

    [theme.breakpoints.down('lg')]: {
      maxWidth: '700px',
      minWidth: '420px',
    },

    [theme.breakpoints.down('sm')]: {
      width: '300px',
      maxWidth: '100%',
      minWidth: 'auto',
    },
  },
  playerWrapper: {
    position: 'relative',
    paddingTop: '56.25%',
    maxWidth: '700px',
    minWidth: '650px',
    height: '100%',
    border: '7px white solid',
    borderRadius: '10px',
    boxShadow:
      '0 13px 27px -5px rgba(50, 50, 93, 0.25), 0 8px 16px -8px rgba(0, 0, 0, 0.3)',
    [theme.breakpoints.down('lg')]: { minWidth: '550px' },
    [theme.breakpoints.down('md')]: { minWidth: '500px' },

    [theme.breakpoints.down('xs')]: {
      minWidth: '350px',
    },
  },
}));

export const FeatureContent = ({
  image,
  thumbnailVideoUrl,
  videoVariant,
  computedDirection,
}) => {
  const { handleSelectThumbnail } = useContext(FeatureThumbnailContext);

  const justify = computedDirection === 'row-reverse';
  const classes = useStyles();

  return (
    <div style={{ display: 'flex', justifyContent: justify }}>
      {image ? (
        <>
          <GatsbyImage
            image={image.featureImage?.asset?.gatsbyImageData}
            alt='chart'
            className={classes.sectionImage}
          />
          {thumbnailVideoUrl ? (
            <div
              style={{
                position: 'absolute',
                height: '500px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  height: '100px',
                  width: '100px',
                  background: '#fff',
                  color: '#002d5c',
                  fontSize: '1.5rem',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow:
                    '0 4px 6px rgba(50,50,93,0.11), 0 1px 3px rgba(0,0,0,0.08)',
                  cursor: 'pointer',
                  zIndex: 5,
                }}
                onClick={(e) => handleSelectThumbnail(e, thumbnailVideoUrl)}
              >
                <FontAwesomeIcon icon={['fas', 'play']} size='lg' />
              </div>
            </div>
          ) : null}
        </>
      ) : videoVariant ? (
        <div className={classes.playerWrapper}>
          <Video url={videoVariant} height='100%' width='100%' controls />
        </div>
      ) : null}
    </div>
  );
};
